import React from 'react';

const FieldGroupLabel = props => {
  return <label className="ui top attached pink huge  label">{props.children}</label>;
};

export default FieldGroupLabel;
